// test616
(616 && 0);
